module.exports = __webpack_public_path__ + "img/info_groups.9b3dd9aa.png";